import "./app.scss"
const scripts = import.meta.glob('./components/**/*.js')

document.addEventListener('DOMContentLoaded', function () {
    for (const path in scripts) {
        scripts[path]().then(
            module => {
                const {default: init} = module
            }
        )
    }

}, false);
